import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReplayIcon from "@mui/icons-material/Replay";
import ToggleOfIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { useQueryClient } from "@tanstack/react-query";
import React from "react";
import { MenuOptionType } from "../../../../../../controls";
import { Job } from "../../../models/Job";

type Props = {
	setShowModal: (modal: "create" | "update" | "reset" | "enable" | "") => void;
	setJobSelected: (job: Job) => void;
};

export const useJobsOptionsFunctions = ({
	setShowModal,
	setJobSelected,
}: Props) => {
	const queryClient = useQueryClient();

	const getMenuOptions = (data: Job) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Job",
				key: "new_job",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Enable Job",
					key: "enable_job",
					disabled: data.Enabled ? true : false,
					onClick: () => {
						setShowModal("enable");
						setJobSelected(data);
					},
					icon: <ToggleOnIcon />,
				},
				{
					name: "Disable Job",
					key: "disable_job",
					disabled: data.Enabled ? false : true,
					onClick: () => {
						setShowModal("enable");
						setJobSelected(data);
					},
					icon: <ToggleOfIcon />,
				},
				{
					name: "Reset Job",
					key: "reset_job",
					onClick: () => {
						setShowModal("reset");
						setJobSelected(data);
					},
					icon: <ReplayIcon />,
				},
			]);
		}
		options = options.concat([
			{
				name: "Refresh Job",
				key: "refresh_job",
				onClick: () => {
					queryClient.invalidateQueries({ queryKey: ["jobs"] });
				},
				icon: <RefreshIcon />,
			},
		]);
		return options;
	};
	return {
		getMenuOptions,
	};
};
